import React,{Component} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  
  Row,
  Col,
 
} from "shards-react";

import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';

import { ChatFeed, Message } from 'react-chat-ui'

import './message.css';


export default class MessagePanel extends Component{

  constructor(props) {
    super(props);
  
    this.state = {date:"null",dateobject:null,
    messages: [
   /* new Message({
      id: 1,
      message: "I'm the recipient! (The person you're talking to)",
    }), // Gray bubble
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }), // Blue bubble
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 1, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 0, message: "I'm you -- the blue bubble!" }),
    new Message({ id: 1, message: "I'm you -- the blue bubble!" }), */
  ],};

    this.setDate = this.setDate.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.get_messages = this.get_messages.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
  }

 
  onSendMessage = ( new_message ) =>{
      var code = this.props.selected_student.class+":"+this.props.selected_student.roll_no;
      var ref = firebase.firestore().collection('Messages').doc(code);

      var data={
        id:'school',
        message:new_message,
        createAt:new Date(),
      }

      var that = this;

      if(this.state.messages.length>0){
          ref.update({messages: firebase.firestore.FieldValue.arrayUnion(data)}).then(function(){
            console.log("message  updated succesfully ");
            that.get_messages();
           }).catch(function(err){console.log(err);window.alert("Unable to send message")});
      }
      else{
        var messages = [];
        messages.push(data);
        ref.set({messages:messages}).then(function(){
            console.log("message succesfully set");
        }).catch(function(err){console.log(err);window.alert("Unable to send message")});
      }

  }

  get_messages = ( ) =>{
      var that = this;
      this.setState({loading:true,messages:[]});
      var code = this.props.selected_student.class+":"+this.props.selected_student.roll_no;
      firebase.firestore().collection("Messages").doc(code).onSnapshot(function(doc) {
          if(doc.exists){
              var message_raw_data = doc.data().messages;
              var message_data  = [];

              message_raw_data.forEach(function(message){
                  if(message.id==="school"){
                      var data = {
                          id:0,
                          message:message.message
                      }
                      message_data.push(new Message(data));
                  }
                  else{

                      var data = {
                          id:1,
                          message:message.message
                      }
                      message_data.push(new Message(data));
                  }
              })

              that.setState({messages:message_data});

          }
    });

  } 

  componentDidUpdate(prevProps) {
       
    if(this.props.selected_student!==undefined){

        if(prevProps.selected_student!==undefined){
          
           if (this.props.selected_student.class !== prevProps.selected_student.class) {
                console.log("Class Changed");

                this.get_messages();
             
            }
            
            else if(this.props.selected_student.roll_no!== prevProps.selected_student.roll_no){
                console.log("Roll no changed");
                this.get_messages();
               
            }

        }
        else{
          console.log(this.props.selected_student);
          this.get_messages()
        }
        
        

    } 
  }

  setDate=(date)=>{
        var dd = (date.getDate()).toString();
        var mm = (date.getMonth()+1).toString();
        var yyyy = (date.getFullYear()).toString();
        
        
        if(dd.length===1){
            dd = '0' + dd;
        }
        if(mm.length===1){
          mm = '0' + mm;
        }
        if(yyyy.length===1){
           yyyy = '0' + yyyy;
        }
        var format  = dd+"/"+mm+"/"+yyyy;
        this.setState({date:format});
  }

   handleDateChange(value) {
        this.setState({dateobject:new Date(value)})
        this.setDate(new Date(value));
    }

  componentDidMount(){

    this.handleDateChange(new Date());
  }

  render(){
   
    

    return(
      <Card small className="mb-4">
      { 
      this.props.selected_student!==undefined &&
    <CardHeader className="border-bottom" style={{backgroundColor: 'blue'}}>

      <div style={{marginLeft: '5%'}}>
        <Row>
          <div className="blog-comments__avatar mr-3">
            <img src={this.props.selected_student.url === null ? "https://png.pngtree.com/svg/20161212/f93e57629c.svg": this.props.selected_student.url} 
                  alt={this.props.selected_student.name} />
          </div>
          <div>
            <strong className=" d-block mb-0" style={{marginTop: '5%',fontSize: 20,color:'white',fontWeight: 'bold' }}>
              {this.props.selected_student.name}
            </strong>
            <strong style={{fontSize: 10,color:'white',fontWeight: 'bold'}}>
                {"Roll No "+this.props.selected_student.roll_no}
            </strong>
          </div>
          </Row>
        </div>
      
    </CardHeader>
  }
    <CardBody className="pt-0" style={{backgroundColor:'white',height: '400px',}}> 
      
  <Col style={{height: '350px'}} className={"chatbox"} >

    { this.props.selected_student!==undefined &&
    <ChatFeed
      messages={this.state.messages} // Boolean: list of message objects
      isTyping={this.state.is_typing} // Boolean: is the recipient typing
      hasInputField={false} // Boolean: use our input, or use your own
      showSenderName // show the name of the user who sent the message
      bubblesCentered={false} //Boolean should the bubbles be centered in the feed?
      // JSON: Custom bubble styles
      bubbleStyles={
        {
          text: {
            fontSize: 15 
          },
          chatbubble: {
            borderRadius: 70,
            padding: 10
          }
        }
      }
    />
  }         
    {this.props.selected_student===undefined &&
                   <div style={{margin: '17%'}} className="text-muted">
                        <div  style={{fontSize:55,textAlign: 'center',color:'blue'}}>
                            <i class="material-icons">error_outline</i>
                        </div>
                        <div  style={{fontSize:25,textAlign: 'center',color:'blue'}}>
                          {"Select the Student"}
                        </div>  
                  </div>
        }
        {
          ((this.props.selected_student!==undefined) && (this.state.messages.length===0)) &&

            <div style={{margin: '17%'}} className="text-muted">
                        <div  style={{fontSize:55,textAlign: 'center',color:'blue'}}>
                            <i class="material-icons">error_outline</i>
                        </div>
                        <div  style={{fontSize:25,textAlign: 'center',color:'blue'}}>
                          {"No Messages Yet"}
                        </div>  
                  </div>

        }                   
  </Col>

  {this.props.selected_student!==undefined &&
  <Col style={{width:'100%'}}>
      <Input 
         onSendMessage={this.onSendMessage}
      />
  </Col>
}
 

                  
                  

    </CardBody>
  </Card>
)
  }
}



class Input extends Component {
  state = {
    text: ""
  }


  onChange(e) {
    this.setState({text: e.target.value});
  }
  onSubmit(e) {
    e.preventDefault();
    this.setState({text: ""});
    this.props.onSendMessage(this.state.text);
  }

  render() {
  return (
    <div className="Input">
      <form onSubmit={e => this.onSubmit(e)}
          className={"form"}>
        <input
          className={"input"}
          onChange={e => this.onChange(e)}
          value={this.state.text}
          type="text"
          placeholder="Enter your message and press ENTER"
          autofocus="true"
        />
        <button className={"button"}><i class="material-icons">send</i></button>
      </form>
    </div>
  );
}

}

